import React from "react";
import { Link, Outlet, NavLink } from "react-router-dom";
import BrandLogo from "@/components/brand/BrandLogo";
import { useAuth } from "@/contexts/AuthContext";

const links = [
    { to: "/comment-ca-marche", label: "Comment ça marche" },
    { to: "/devenir-dresseur", label: "Devenir dresseur" },
    { to: "/faq", label: "FAQ" },
];

function navLinkClass({ isActive }) {
    return `text-sm font-medium transition-colors ${
        isActive ? "text-md-text" : "text-md-text-2 hover:text-md-text"
    }`;
}

export function PublicLayout() {
    const { user } = useAuth();
    return (
        <div className="flex min-h-screen flex-col bg-md-bg">
            <header className="sticky top-0 z-40 md-glass border-b border-md-border">
                <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
                    <BrandLogo variant="horizontal" size="sm" to="/" />
                    <nav className="hidden items-center gap-6 md:flex" aria-label="Public">
                        {links.map((l) => (
                            <NavLink key={l.to} to={l.to} className={navLinkClass} data-testid={`public-nav-${l.to.replace(/[/]/g, "")}`}>
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                    <div className="flex items-center gap-2">
                        {user && user !== false ? (
                            <Link
                                to="/app"
                                data-testid="public-cta-open-app"
                                className="inline-flex h-9 items-center rounded-full bg-md-primary px-4 text-sm font-semibold text-md-primary-fg hover:opacity-90"
                            >
                                Ouvrir l’app
                            </Link>
                        ) : (
                            <>
                                <Link
                                    to="/login"
                                    data-testid="public-cta-login"
                                    className="hidden sm:inline-flex h-9 items-center rounded-full px-4 text-sm font-medium text-md-text hover:bg-md-surface-2"
                                >
                                    Se connecter
                                </Link>
                                <Link
                                    to="/register"
                                    data-testid="public-cta-register"
                                    className="inline-flex h-9 items-center rounded-full bg-md-primary px-4 text-sm font-semibold text-md-primary-fg hover:opacity-90"
                                >
                                    Rejoindre l’aventure
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </header>
            <main className="flex-1">
                <Outlet />
            </main>
            <footer className="border-t border-md-border bg-md-surface">
                <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:grid-cols-2 lg:grid-cols-4 sm:px-6">
                    <div>
                        <BrandLogo variant="horizontal" size="sm" to="/" />
                        <p className="mt-4 max-w-xs text-sm text-md-text-2">
                            Les doubles des uns complètent les classeurs des autres.
                        </p>
                    </div>
                    <div>
                        <p className="md-overline">Aventure</p>
                        <ul className="mt-3 space-y-2 text-sm">
                            <li><Link to="/comment-ca-marche" className="text-md-text-2 hover:text-md-text">Comment ça marche</Link></li>
                            <li><Link to="/devenir-dresseur" className="text-md-text-2 hover:text-md-text">Devenir dresseur</Link></li>
                            <li><Link to="/charte" className="text-md-text-2 hover:text-md-text">Charte du dresseur</Link></li>
                            <li><Link to="/faq" className="text-md-text-2 hover:text-md-text">FAQ</Link></li>
                        </ul>
                    </div>
                    <div>
                        <p className="md-overline">Légal</p>
                        <ul className="mt-3 space-y-2 text-sm">
                            <li><Link to="/cgu" className="text-md-text-2 hover:text-md-text">CGU</Link></li>
                            <li><Link to="/confidentialite" className="text-md-text-2 hover:text-md-text">Confidentialité</Link></li>
                            <li><Link to="/mentions-legales" className="text-md-text-2 hover:text-md-text">Mentions légales</Link></li>
                        </ul>
                    </div>
                    <div>
                        <p className="md-overline">Plateforme</p>
                        <ul className="mt-3 space-y-2 text-sm">
                            <li><Link to="/app" className="text-md-text-2 hover:text-md-text">Ouvrir l’app</Link></li>
                            <li><Link to="/admin/login" className="text-md-text-2 hover:text-md-text">Espace admin</Link></li>
                            <li>
                                <a
                                    href={`${process.env.REACT_APP_BACKEND_URL}/api/public/doctrine.pdf`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-doctrine-link"
                                    className="text-md-text-2 hover:text-md-text"
                                >
                                    Doctrine produit (PDF)
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-md-border">
                    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-md-text-2 sm:flex-row sm:px-6">
                        <span>© {new Date().getFullYear()} Mission Dresseur — Aventure collaborative</span>
                        <span>Phase 1 · Architecture &amp; design system</span>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default PublicLayout;
